export const ADD_USERS_PREFERENCE_REQUEST = " ADD_USERS_PREFERENCE_REQUEST";
export const ADD_USERS_PREFERENCE_SUCCESS = " ADD_USERS_PREFERENCE_SUCCESS";
export const ADD_USERS_PREFERENCE_FAILURE = " ADD_USERS_PREFERENCE_FAILURE";
